(ns app.front.view.admin.migration.property-geojson
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/convert-property-shapes-to-geojson
    :title     "Convert old property shapes to GeoJSON"
    :help-text (str "Pre-mid-2021 location shape data was saved in ArcGIS format. This migration will convert those "
                    "shapes to GeoJSON format.")}
   match])

(def route
  {:name        :view/admin.migration.property-geojson
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/convert-property-shapes-to-geojson]))}]})
